import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { environment as env } from '../../environments/environment';
import { ApiAuthHttpClient } from '../http/ApiAuthHttpClient';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class LogChangesService {
    constructor(private http: ApiAuthHttpClient) {}

    getLogsForCustomer(customerId: string): Observable<any> {
        return this.http.get(`${env.apiPath}log-changes/customer/${customerId}`).pipe(
            map((data: any) => {
                return data.data;
            })
        );
    }

    getLogsForOrder(orderID: string): Observable<any> {
        return this.http.get(`${env.apiPath}log-changes/order/${orderID}`).pipe(
            map((data: any) => {
                return data.data;
            })
        );
    }
}
